import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74bd0b78"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = {
  class: "modal2",
  style: {"width":"900px"}
}
const _hoisted_3 = { class: "modal-header flex-row flex-align-center" }
const _hoisted_4 = { class: "text-center flex-1 modal-header-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#333",
    d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body flex-row flex-wrap" }
const _hoisted_8 = { class: "table table-borderless" }
const _hoisted_9 = { id: "article-content-tr" }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { class: "flex-row-center modal-footer2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RichEditor = _resolveComponent("RichEditor")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
              class: "modal-header-close"
            }, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _createElementVNode("tr", _hoisted_9, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_RichEditor, {
                      modelValue: _ctx.itemData.data.content,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemData.data.content) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, "提交")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}